/* eslint-disable no-param-reassign */
import { Dolan, DolanV4 } from '@sapappgyver/appgyver-descriptors/lib/dolan';
import getAllFontsInDolan from '../../fonts/getAllFontsInDolan';
import ensureDescriptorIsLatestSupportedVersion from '../ensureDescriptorIsLatestSupportedVersion';

const migrateDolan = (dolan: Dolan): DolanV4 => ({
  ...ensureDescriptorIsLatestSupportedVersion(dolan),
  fonts: getAllFontsInDolan(dolan),
});

export default migrateDolan;
